import InteractionEvent, {
  type InteractionTargetType
} from './InteractionEvent';

export type DismissPlacement = 'dismiss_button';

// Which banner was closed. A banner's seen record is its click's type, so dbt joins a dismiss to
// it on view_id and this value: app_download is the navigation_link impression at app_banner,
// notification the notification impression at banner.
export type DismissBannerType = 'app_download' | 'notification';

export type DismissTargetProperties = {
  banner_type: DismissBannerType;
  placement: DismissPlacement;
};

type EventData = {
  bannerType: DismissBannerType;
  gesture?: string;
  guestId?: string;
  isBot: boolean;
  placement: DismissPlacement;
};

class DismissInteractionEvent extends InteractionEvent<
  EventData,
  DismissTargetProperties
> {
  protected get targetType(): InteractionTargetType {
    return 'dismiss';
  }

  protected getTargetProperties(): DismissTargetProperties {
    return {
      banner_type: this.data.bannerType,
      placement: this.data.placement
    };
  }
}

export default DismissInteractionEvent;
